/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Events_Imported_ToastInputs */



/**
* | output |
* | --- |
* | "OCR results imported as event group." |
*
* @param {Ocr_Events_Imported_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_events_imported_toast = /** @type {((inputs?: Ocr_Events_Imported_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Events_Imported_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résultats de la reconnaissance optique de caractères (OCR) importés en tant que groupe d'événements.")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR-Ergebnisse wurden als Ereignisgruppe importiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I risultati dell'OCR sono stati importati come gruppo di eventi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Результаты распознавания текста импортированы как группа событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los resultados del OCR se importaron como grupo de eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OCR结果以事件组的形式导入。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCRの結果はイベントグループとしてインポートされます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("OCR परिणामों को इवेंट समूह के रूप में आयात किया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resultados de OCR importados como grupo de eventos.")
	return /** @type {LocalizedString} */ ("OCR results imported as event group.")
});